export const MerchantState = {
    /** 정상 */
    STATE_CODE_NORMAL: 'STATE_CODE_NORMAL',
    /** 가입심사 */
    STATE_CODE_SUBSCRIPTION_JUDGMENT: 'STATE_CODE_SUBSCRIPTION_JUDGMENT',
    /** 연동 */
    STATE_CODE_INTERLOCK: 'STATE_CODE_INTERLOCK',
    /** 탈퇴요청 */
    STATE_CODE_LEAVE_REQUEST: 'STATE_CODE_LEAVE_REQUEST',
    /** 탈퇴 */
    STATE_CODE_LEAVE_COMPLETE: 'STATE_CODE_LEAVE_COMPLETE',
    /** 휴면(거래중지) */
    STATE_CODE_TRADE_INTERRUPTION: 'STATE_CODE_TRADE_INTERRUPTION',
} as const

export type MerchantStateType = Constant<typeof MerchantState>

export const MerchantType = {
    /** 개인 판매회원 */
    PERSONAL: 'PSN',
    /** 사업자 판매회원 */
    BUSINESS: 'BSN',
    /** 국내 거주 개인 판매회원 */
    DOMESTIC_PERSONAL: 'DPSN',
    /** 국내 거주 사업자 판매회원 */
    DOMESTIC_BUSINESS: 'DBSN',
    /** 해외 거주 개인 판매회원 */
    OVERSEAS_PERSONAL: 'OPSN',
    /** 해외 거주 사업자 판매회원 */
    OVERSEAS_BUSINESS: 'OBSN',
} as const

export type MerchantTypeValue = Constant<typeof MerchantType>
